import { AdminPage } from './components/AdminPage'
import { AgentRoster } from './components/AgentRoster'
import { ChainRail } from './components/ChainRail'
import { HouseWar } from './components/HouseWar'
import { Leaderboard } from './components/Leaderboard'
import { PnlChart } from './components/PnlChart'
import { PositionsPanel } from './components/PositionsPanel'
import { StartPanel } from './components/StartPanel'
import { ThoughtStream } from './components/ThoughtStream'
import { TopBar } from './components/TopBar'
import { TradeTape } from './components/TradeTape'
import { useNow } from './core/useNow'
import { useRoute } from './core/useRoute'
import { activateCompetition, useCompetition, useCompetitionFeed } from './data/useCompetition'

/* The whole layout is three rails around one chart. Panels are self-contained,
   so moving one between rails is a line move, not a refactor.

   Before the round is opened every panel shows the same standby card. The one
   control that opens it lives on the operator console at #/admin, not here. */
export default function App() {
  useCompetitionFeed()
  const state = useCompetition()
  const now = useNow()
  const route = useRoute()
  const standby = state.meta.phase === 'standby'

  if (route === 'admin') return <AdminPage state={state} onActivate={activateCompetition} />

  return (
    <div className="shell">
      <TopBar state={state} now={now} />
      <ChainRail quotes={state.quotes} />

      <main className="grid">
        <div className="rail rail--left">
          <AgentRoster state={state} standby={standby} />
          <PositionsPanel positions={state.positions} now={now} standby={standby} />
          <TradeTape trades={state.trades} standby={standby} />
        </div>

        <div className="col col--center">
          {standby ? <StartPanel state={state} /> : <PnlChart state={state} />}
          <HouseWar houses={state.houses} standby={standby} />
          <Leaderboard rows={state.leaderboard} standby={standby} />
        </div>

        <div className="rail rail--right">
          <ThoughtStream thoughts={state.thoughts} now={now} standby={standby} />
        </div>
      </main>
    </div>
  )
}
